import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useChartData } from '../../context/ChartContext';
import { useScale } from '../../context/ScaleContext';
import { useActiveSpectrum } from '../../hooks/useActiveSpectrum';
import { useActiveSpectrumPeaksViewState } from '../../hooks/useActiveSpectrumPeaksViewState';
import useSpectrum from '../../hooks/useSpectrum';
import { usePeakShapesPath } from './usePeakShapesPath';
const emptyData = { peaks: {}, display: {} };
function PeaksShapes() {
    const { displayerKey } = useChartData();
    const { shiftY } = useScale();
    const { showPeaksShapes, showPeaksSum } = useActiveSpectrumPeaksViewState();
    const activeSpectrum = useActiveSpectrum();
    const spectrum = useSpectrum(emptyData);
    if (!spectrum?.peaks?.values || !spectrum.display.isVisible) {
        return null;
    }
    const shift = (activeSpectrum?.index || 0) * shiftY;
    return (_jsxs("g", { className: "peaks-shapes", clipPath: `url(#${displayerKey}clip-chart-1d)`, children: [showPeaksShapes && _jsx(PeaksShapesItems, { vAlign: shift }), showPeaksSum && _jsx(PeaksShapesSum, { vAlign: shift })] }));
}
function PeaksShapesItems(props) {
    const spectrum = useSpectrum(emptyData);
    const getPath = usePeakShapesPath(spectrum);
    return (_jsxs("g", { children: [' ', spectrum.peaks.values.map((peak) => {
                const { fill, path } = getPath({ target: 'peakShape', peak });
                return (_jsx("path", { fill: fill, fillOpacity: 0.3, d: path, transform: `translate(0,-${props.vAlign})` }, peak.id));
            })] }));
}
function PeaksShapesSum(props) {
    const spectrum = useSpectrum(emptyData);
    const getPath = usePeakShapesPath(spectrum);
    const { fill, path } = getPath({
        target: 'peaksSum',
        peaks: spectrum.peaks.values,
    });
    return (_jsx("path", { stroke: 'darkblue', fill: fill, d: path, transform: `translate(0,-${props.vAlign})` }));
}
export default PeaksShapes;
